<template>
    <Layout title="Buchen" h1="Buchen" :banner="$page.props.banner">
        <booking @on-next="onNext">
            <div class="row">
                <div class="col-md-6 order-2 order-md-1">
                    <div v-if="travelExists">
                        <img :src="travelInfo.data.teaserMediumUrls[0]" class="card-img-top mb-3" alt="Urlaubsziel" />
                        <strong>{{ travelInfo.get('destination') }}</strong>
                        <p v-html="travelInfo.get('description')"></p>
                    </div>
                </div>
                <div class="col-md-6 my-4 my-md-0 order-1 order-md-2">

                    <booking-form @submit.prevent="onSubmit">
                        <label for="travel-search" class="form-label">Ort</label>
                        <locations v-model:search="form.search" v-model:code="form.code" input-class="form-control-booking form-control-pen border-bottom border-dark" :locations="searchLocations" />
                        <div class="mt-3" v-if="travelExists">
                            <label for="travel-date-id" class="form-label">Termin</label>
                            <select class="form-select form-select-booking border-bottom border-dark" v-model="form.tdid" id="travel-date-id">
                                <option v-for="travelDate in $page.props.searchTravelDates" :key="'travel-date-' + travelDate.id" :value="travelDate.id" :disabled="travelDate.bookedOut">
                                    {{ new Date(travelDate.from).toLocaleDateString("de-DE", { day: '2-digit', month: '2-digit', year: 'numeric' }) }} -
                                    {{ new Date(travelDate.to).toLocaleDateString("de-DE", { day: '2-digit', month: '2-digit', year: 'numeric' }) }}, {{ travelDate.days }} Tage
                                    <span v-if="travelDate.bookedOut">- Ausgebucht</span>
                                </option>
                            </select>
                        </div>

                        <div v-if="errors.travel_date_id" class="text-danger">{{ errors.travel_date_id }}</div>
                    </booking-form>

                </div>
            </div>
        </booking>
    </Layout>
</template>
<script>
import { Link, useForm } from "@inertiajs/inertia-vue3";
import Layout from "../Layouts/Booking";
import Booking from "./Booking";
import BookingForm from "./Form";
import Travel from "../../Models/Travel";
import TravelInfo from "../../Models/TravelInfo";
import TravelDate from "../../Models/TravelDate";
import Locations from "../../Components/Scol/Locations";
import { store } from "../../store";

export default {
    components: {
        Layout,
        Link,
        Booking,
        BookingForm,
        Locations,
    },
    props: {
        errors: Object,
        bookingForm: Object,
        searchLocations: Object,
    },
    data: () => ({
        store,
        form: useForm({
            search: null,
            code: null,
            tdid: null,
        }),
    }),
    watch: {
        "form.code"() {
            this.reloadOnly(["travel", "travelInfo", "travelDate", "searchTravelDates"]);
        },
        "form.tdid"(value) {
            this.$session
                .set("travel_date_id", value)
                .syncToServer()
                .then(() => this.reloadOnly(["travelDate", "searchTravelDates"]));
        },
    },
    methods: {
        onSubmit() {
            store.loading = true;
            this.$inertia.visit(
                this.$route("booking.step2", {
                    travelDate: this.travelDate.get("slug"),
                }),
                {
                    data: { t: this.$session.tab_id },
                    onFinish: () => store.loading = false,
                }
            );
        },
        onNext() {
            this.onSubmit();
        },
        onTravelDateSelect() {
            store.loading = true;
            this.$inertia.visit(
                this.$route("booking.step1", {
                    travelDate: this.form.tdid,
                }),
                {
                    data: { t: this.$session.tab_id },
                    onFinish: () => store.loading = false,
                }
            );
        },
        reloadOnly(only) {
            store.loading = true;
            this.$inertia.reload({
                data: {
                    t: this.$session.tab_id,
                    code: this.form.code,
                    tdid: this.form.tdid,
                },
                only: only,
                onSuccess: () => {
                    store.loading = false;
                },
            });
        },
        reloadDates() {
            this.$inertia.reload({
                data: { t: this.$session.tab_id, code: this.form.code },
                only: ["travel", 'travelInfo', "searchTravelDates"],
            });
        },
        travelChanged(code) {
            console.log(this.form);
            if (this.travelDateExists && this.travel.get("code") != code) {
                // console.log("reload");
                this.$inertia.reload({
                    data: { t: this.$session.tab_id, code: code },
                    only: ["searchTravelDates"],
                });
                // this.$inertia.visit(this.$route("booking.step1"), {
                //   data: { t: this.$session.tab_id, tid: _.get(newTravel, "id") },
                // });
            }
        },
    },
    mounted() {
        this.form.search = this.travelInfo.get("destination");
        this.form.code = this.travel.get("code");
        this.form.tdid = this.travelDate.get("id");

        console.log(this.form.code);
    },
    computed: {
        travelDate() {
            return new TravelDate(this.$page.props.travelDate);
        },
        travel() {
            return new Travel(this.$page.props.travel);
        },
        travelInfo() {
            return new TravelInfo(this.$page.props.travelInfo);
        },
        travelExists() {
            return this.travel.get("id");
        },
        travelDateExists() {
            return this.travelDate.get("id");
        },
    },
};
</script>
